interface ChatBubbleProps {
  message: string
  isOwn: boolean
  timestamp: Date
}

export function ChatBubble({ message, isOwn, timestamp }: ChatBubbleProps) {
  const time = new Date(timestamp).toLocaleTimeString('nb-NO', {
    hour: '2-digit',
    minute: '2-digit'
  })

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[75%] ${isOwn ? 'order-2' : 'order-1'}`}>
        <div
          className={`rounded-2xl px-4 py-3 ${
            isOwn
              ? 'bg-red-500 text-white rounded-br-sm'
              : 'bg-gray-700 border border-gray-600 text-white rounded-bl-sm'
          }`}
        >
          <p className="text-sm leading-relaxed">{message}</p>
        </div>
        <p
          className={`text-xs text-gray-400 mt-1 px-2 ${
            isOwn ? 'text-right' : 'text-left'
          }`}
        >
          {time}
        </p>
      </div>
    </div>
  )
}
